// Lightweight scroll progress store shared between DOM and the <Canvas>.
// No re-renders — R3F components read `scrollStore.get()` inside useFrame.

let progress = 0;
let stage = "hook";
const listeners = new Set();

export const scrollStore = {
  get: () => progress,
  getStage: () => stage,
  set: (p, s) => {
    progress = p;
    if (s) stage = s;
    listeners.forEach((fn) => fn(p, s));
  },
  setStage: (s) => {
    stage = s;
    listeners.forEach((fn) => fn(progress, s));
  },
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

// Resolve current chapter name from progress
export function stageFromProgress(p, stages) {
  for (const [name, [a, b]] of Object.entries(stages)) {
    if (p >= a && p < b) return name;
  }
  return "signal";
}

// Map a value from [a,b] -> [0,1], clamped
export function mapRange(p, a, b) {
  if (b === a) return 0;
  const t = (p - a) / (b - a);
  return Math.max(0, Math.min(1, t));
}

// Smooth bell curve: returns 1 at `center`, 0 at `center ± half`
export function bell(p, center, half) {
  const d = Math.abs(p - center) / half;
  if (d >= 1) return 0;
  // cosine bell
  return 0.5 + 0.5 * Math.cos(Math.PI * d);
}

// Ease in-out cubic
export const easeInOut = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

// Basic lerp
export const lerp = (a, b, t) => a + (b - a) * t;
